import React from 'react';
import {MasterLayout} from 'layout';
import {DanhSachCuocThanhTra} from 'modules/thanh-tra';

export default class DanhSachCuocThanhTraPage extends React.Component {
  
  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <DanhSachCuocThanhTra/>
      </MasterLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/thanh-tra/DanhSachCuocThanhTraPage.jsx